import { notification } from 'antd';

const openNotif = (type, title, message, otherProps) => {
  return notification[type]({
    message: title,
    description: message,
    ...otherProps,
  });
};

const success = (message, otherProps) => openNotif('success', 'Sucesso', message, otherProps);
const info = (message, otherProps) => openNotif('info', 'Informação', message, otherProps);
const warning = (message, otherProps) => openNotif('warning', 'Atenção', message, otherProps);
const error = (message, otherProps) => openNotif('error', 'Erro', message, otherProps);

export default {
  success,
  info,
  warning,
  error,
};
